import { useState, useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import nav1 from "../assets/nav-1.png";
import nav2 from "../assets/nav-2.png";
import nav3 from "../assets/nav-3.png";
import nav4 from "../assets/nav-4.png";
import nav5 from "../assets/nav-5.png";

const Navbar = () => {
  const [activeDropdown, setActiveDropdown] = useState("");
  const [isMobileFeaturesOpen, setIsMobileFeaturesOpen] = useState(false);
  const menuRef = useRef();
  const menuButtonRef = useRef();
  const featuresRef = useRef();

  const location = useLocation();

  const featurePaths = ["/bonuses", "/jackpot"];
  const featureHeadings = ["BONUSES", "JACKPOT"];
  const isFeatureActive = featurePaths.includes(location.pathname);

  const handleNavClick = () => {
    setActiveDropdown("");
    setIsMobileFeaturesOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      // If dropdown is open and the click was outside both menu and toggle button
      if (
        activeDropdown === "menu" &&
        menuRef.current &&
        !menuRef.current.contains(event.target) &&
        menuButtonRef.current &&
        !menuButtonRef.current.contains(event.target)
      ) {
        setActiveDropdown("");
      }

      if (
        activeDropdown === "features" &&
        featuresRef.current &&
        !featuresRef.current.contains(event.target)
      ) {
        setActiveDropdown("");
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, [activeDropdown]);

  return (
    <nav className="bg-black/90 text-white shadow-lg fixed top-0 w-full z-50">
      <div className="max-w-[1400px] mx-auto flex justify-between items-center lg:py-4 py-2 lg:px-6 px-4">
        <Link to="/" className="text-xl font-mono oxanium-font lg:ml-12 ml-4">
          <div className="tracking-widest letter_spacing">FUSION</div>
          <div className="tracking-widest letter_spacing">SPIN</div>
        </Link>

        {/* Desktop Navigation */}
        <ul className="hidden xl:flex flex-wrap justify-center space-x-6 xl:space-x-8 2xl:space-x-14 poppins-font">
          <li className="flex items-center space-x-2 text-[12px]">
            <img src={nav1} alt="Home" />
            <Link to="/" className={location.pathname === "/" ? "text-orange-500" : "text-white"} onClick={handleNavClick}>HOME</Link>
          </li>
          <li className="flex items-center space-x-2 text-[12px]">
            <img src={nav2} alt="About" />
            <Link to="/about" className={location.pathname === "/about" ? "text-orange-500" : "text-white"} onClick={handleNavClick}>ABOUT</Link>
          </li>
          <li className="flex items-center space-x-2 text-[12px]">
            <img src={nav3} alt="Slots" />
            <Link to="/slots" className={location.pathname === "/slots" ? "text-orange-500" : "text-white"} onClick={handleNavClick}>SLOTS</Link>
          </li>
          <li className="flex items-center space-x-2 text-[12px]">
            <img src={nav2} alt="Hardware" />
            <Link to="/hardware" className={location.pathname === "/hardware" ? "text-orange-500" : "text-white"} onClick={handleNavClick}>HARDWARE</Link>
          </li>

          {/* Features Dropdown */}
          <li ref={featuresRef} className="relative">
            <div className={` flex items-center space-x-2 text-[12px] cursor-pointer ${isFeatureActive ? "text-orange-500" : "text-white"}`} onClick={() => setActiveDropdown(activeDropdown === "features" ? "" : "features")}>
              <img src={nav3} alt="Features" />
              <span>FEATURES</span>
            </div>
            {activeDropdown === "features" && (
              <ul className="absolute left-0 mt-8 w-48 bg-white border border-gray-300 shadow-lg rounded-lg z-50">
                {featurePaths.map((path, index) => (
                  <li key={path} className={`px-4 py-2 hover:bg-gray-100 border-b border-gray-300 text-orange-500 ${index === 0 ? "rounded-t-lg" : ""} ${index === featurePaths.length - 1 ? "rounded-b-lg border-b-0" : ""}`}>
                    <Link to={path} onClick={handleNavClick}>{featureHeadings[index]}</Link>
                  </li>
                ))}
              </ul>
            )}
          </li>

          <li className="flex items-center space-x-2 text-[12px]">
            <img src={nav4} alt="Management Software" />
            <Link to="/management-software" className={location.pathname === "/management-software" ? "text-orange-500" : "text-white"} onClick={handleNavClick}>MANAGEMENT SOFTWARE</Link>
          </li>
          <li className="flex items-center space-x-2 text-[12px]">
            <img src={nav5} alt="Contact" />
            <Link to="/contact" className={location.pathname === "/contact" ? "text-orange-500" : "text-white"} onClick={handleNavClick}>CONTACT</Link>
          </li>
        </ul>

        {/* Mobile Menu Button */}
        <button
          ref={menuButtonRef}
          className="xl:hidden text-white focus:outline-none p-3 text-3xl w-[48px] h-[48px] flex items-center justify-center"
          onClick={() => setActiveDropdown(activeDropdown === "menu" ? "" : "menu")}
        >
          {activeDropdown === "menu" ? (<span className="text-4xl font-bold md:text-5xl">✕</span>) : (<span className="text-4xl md:text-5xl">☰</span>)}
        </button>
      </div>

      {/* Mobile Menu */}
      {activeDropdown === "menu" && (
        <div ref={menuRef} className="xl:hidden bg-black/10 w-full px-6 py-8 z-50">
          <ul className="flex flex-col text-white space-y-8">
            <li className="flex items-center space-x-2 text-[14px]"><img src={nav1} alt="Home" /><Link to="/" onClick={handleNavClick}>HOME</Link></li>
            <li className="flex items-center space-x-2 text-[14px]"><img src={nav2} alt="About" /><Link to="/about" onClick={handleNavClick}>ABOUT</Link></li>
            <li className="flex items-center space-x-2 text-[14px]"><img src={nav3} alt="Slots" /><Link to="/slots" onClick={handleNavClick}>SLOTS</Link></li>
            <li className="flex items-center space-x-2 text-[14px]"><img src={nav2} alt="Hardware" /><Link to="/hardware" onClick={handleNavClick}>HARDWARE</Link></li>

            <li className="flex flex-col space-y-2 text-[14px]">
              <div className="flex items-center space-x-2 cursor-pointer" onClick={() => setIsMobileFeaturesOpen(!isMobileFeaturesOpen)}>
                <img src={nav3} alt="Features" /><span>FEATURES ▼</span>
              </div>
              {isMobileFeaturesOpen && (
                <ul className="ml-8 flex flex-col space-y-4 py-2">
                  {featurePaths.map((path, index) => (
                    <li key={path}>
                      <Link to={path} onClick={handleNavClick} className="text-gray-100">{featureHeadings[index]}</Link>
                    </li>
                  ))}
                </ul>
              )}
            </li>

            <li className="flex items-center space-x-2 text-[14px]"><img src={nav4} alt="Management Software" /><Link to="/management-software" onClick={handleNavClick}>MANAGEMENT SOFTWARE</Link></li>
            <li className="flex items-center space-x-2 text-[14px]"><img src={nav5} alt="Contact" /><Link to="/contact" onClick={handleNavClick}>CONTACT</Link></li>
          </ul>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
